import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private appService: AppService, private router: Router) { }

  search(params: any): Promise<boolean> {
    return this.router.navigate(['/result'], { queryParams: params });
  }

  searchServiceProviders(params: any): Observable<HttpResponse<any[]>> {
    const serverParams = { ...params, page: 0, size: 1000 };
    console.log('Search service parameter: ' + JSON.stringify(serverParams));
    const searchIamTrustedByLocation = !serverParams.toLocation && !serverParams.toCountry && !serverParams.toLatitude && !serverParams.toLongitude && !serverParams.toLatitude;
    console.log('Search IAM Trusted by location: ' + searchIamTrustedByLocation);
    if (serverParams.companyName) {
      return this.appService.searchServiceProvidersByName(serverParams.companyName, serverParams);
    } else if (searchIamTrustedByLocation) {
      return this.appService.searchIamTrustedServiceProvidersByLocation(serverParams);
    }
    return this.appService.searchServiceProvidersByLocation(serverParams);
  }

  searchIamTrustedServiceProvidersByLocation(params: any): Observable<HttpResponse<any[]>> {
    const serverParams = { ...params, page: 0, size: 1000 };
    return this.appService.searchIamTrustedServiceProvidersByLocation(serverParams);
  }

  getAdvertisments(params: any): Observable<HttpResponse<any>> {
    return this.appService.getAdvertisments(params);
  }
}
